<template>
    <table-container>
        <data-iterator ref="iterator" :api="api" :filters.sync="filters">
            <template v-slot:filters="{ busy }">
                <table-filters
                    v-model="filters"
                    :fields="headers"
                    :busy="busy"
                ></table-filters>
            </template>

            <template slot-scope="{ items }">
                <d-table
                    :items="items"
                    :headers="headers"
                    :filters.sync="filters"
                >
                    <template v-slot:item.userId="{ item }">
                        {{ getUserEmail(item) }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-btn small color="primary" @click="openEditModal(item)">
                            <v-icon small left>edit</v-icon>
                            {{ $t('actions.edit') }}
                        </v-btn>
                    </template>
                </d-table>
            </template>
        </data-iterator>

        <auto-login-edit-modal
            v-model="editDialog"
            :item="editItem"
            @saved="onSaved"
        />
    </table-container>
</template>

<script>
import RestApiType from '@/api/RestApiType'
import DataIteratorMixin from '@/components/mixins/DataIteratorMixin'
import DataTableMixin from '@/components/mixins/DataTableMixin'
import AutoLoginEditModal from '@/components/pages/tablets/AutoLoginEditModal'

export default {
    mixins: [DataIteratorMixin, DataTableMixin],

    components: {
        AutoLoginEditModal,
    },

    data() {
        return {
            api: RestApiType.TABLET_AUTO_LOGIN,
            editDialog: false,
            editItem: null,
        }
    },

    computed: {
        headers() {
            return [
                {
                    value: 'id',
                    text: this.$t('labels.id'),
                    type: 'string',
                },
                {
                    value: 'serialNumber',
                    text: this.$t('labels.serial_number'),
                    type: 'string',
                },
                {
                    value: 'name',
                    text: this.$t('labels.name'),
                    type: 'string',
                },
                {
                    value: 'userId',
                    text: this.$t('labels.user'),
                    type: 'string',
                    sortable: false,
                },
                {
                    value: 'createdAt',
                    text: this.$t('labels.created_at'),
                    type: 'string',
                },
                {
                    value: 'updatedAt',
                    text: this.$t('labels.updated_at'),
                    type: 'string',
                },
                {
                    value: 'actions',
                    text: '',
                    sortable: false,
                },
            ]
        },
    },

    methods: {
        getUserEmail(item) {
            if (!item.userId) return '-'
            if (typeof item.userId === 'object' && item.userId.email) {
                return item.userId.email
            }
            return item.userId
        },

        openEditModal(item) {
            this.editItem = item
            this.editDialog = true
        },

        onSaved() {
            this.editDialog = false
            this.updateTableItems()
        },
    },
}
</script>
